import { ALL_CALL_CENTER_PERMISSION_DEFINITIONS } from '@/shared/constants/call-center-permissions';
function actionToAuthorityKey(action) {
    return action
        .replace(/[^a-zA-Z0-9]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '')
        .toUpperCase();
}
const generatedEntries = ALL_CALL_CENTER_PERMISSION_DEFINITIONS.map((def) => [actionToAuthorityKey(def.action), def.action]);
export const AUTHORITIES = Object.freeze({
    ...Object.fromEntries(generatedEntries),
    ADMIN: 'ROLE_ADMIN',
});
